export const ReadSearchTipsLink = () => (
  <a
    href="https://support.dyler.com/hc/en-us/articles/360004004277-How-can-I-perform-a-proper-search-in-the-hot-search-field-"
    target="_blank"
    rel="noopener noreferrer"
  >
    {I18n.t('search.search_tips')}
  </a>
)
